/**
 * Enum for delivery methods
 */
export var DeliveryMethod;
(function (DeliveryMethod) {
    DeliveryMethod["DELIVERY"] = "Delivery";
    DeliveryMethod["COLLECTION"] = "Collection";
})(DeliveryMethod || (DeliveryMethod = {}));
//# sourceMappingURL=sales.js.map